import { type TokenData, TokenMetricNames } from "../models/tokenDO.models";
import { i18n } from "../../internationalize/i18n.service";
// import { tokenDataService } from "../services/tokenData.service";

import '../style/tokenData.css'
import type { TokenDataService } from "../services/tokenData.service";
import { buildTokenData, getMetricColor } from "../helpers/tokenData.helpers";

export class TokenDataContainer extends HTMLElement {
    constructor(private tokenDataService: TokenDataService = window.tbwServices.tokenDataService) {
        super()
        this.classList.add('token-data-container')
    }

    connectedCallback() {
        const tokenSlug = this.getAttribute('data-token-slug')
        if (!tokenSlug) { throw new Error('Token slug not found') }

        this.load()
    }

    async load() {
        const tokenSlug = this.getAttribute('data-token-slug')
        if (!tokenSlug) { throw new Error('Token slug not found') }

        const tokenData = await this.tokenDataService.getTokenData(tokenSlug)
        if (tokenData.length === 0) { throw new Error('No token data found') }

        this.setValues(this, buildTokenData(tokenData[0]))
        this.style.display = 'flex'
    }

    setValues(container: HTMLElement, tokenDataItem: TokenData) {
        // TODO: use keys not strings
        for (const metric in tokenDataItem) {
            const dataBox = document.createElement('div')
            if (tokenDataItem[metric as keyof TokenData] === null) { continue }

            const metricName = i18n.getLanguage() === 'fr' ? TokenMetricNames[metric as keyof typeof TokenMetricNames].french : TokenMetricNames[metric as keyof typeof TokenMetricNames].english
            dataBox.className = 'token-data-box'
            dataBox.innerHTML = `
                <div id='metric' class='caption1'>${metricName}</div>
                <div id='value' class='headline-5'">${tokenDataItem[metric as keyof TokenData]}</div>`

            if (metric === 'percent_change_24h') {
                const color = getMetricColor(tokenDataItem, metric)
                const value: HTMLDivElement | null = dataBox.querySelector('#value')

                if (!value || !value.style) { continue }
                value.style.color = color
            }

            container.appendChild(dataBox)
        }
    }
}